<template>
    <div class="overview mainBody">
        <div class="charts">
            <div class="input_group" v-if="groupList.item1.isShow">
                        <label v-if="groupList.item1.selectOrinput" class="input_label" for="select">{{groupList.item1.lable}}</label>
                        <el-select v-if="groupList.item1.selectOrinput" id="select" class="inputInner" v-model="groupList.item1.selectValue" placeholder="请选择">
                            <el-option
                            v-for="item in groupList.item1.selectOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <label v-if="!groupList.item1.selectOrinput" class="input_label" for="input">{{groupList.item1.lable}}</label>
                        <el-input v-if="!groupList.item1.selectOrinput" id="input" class="inputInner" v-model="groupList.item1.inputValue" placeholder="请输入内容"></el-input>
                    </div>
                    <div id="main">
                        <div class="main_head">
                            <h1>材料进场管理</h1>
                        </div>
                        <div class="main_body">
                            <div id="main1">
                
                             </div>
                        </div>
                    </div>
        </div>
        <div class="charts">
            <div class="input_group" v-if="groupList.item2.isShow">
                        <label v-if="groupList.item2.selectOrinput" class="input_label" for="select">{{groupList.item2.lable}}</label>
                        <el-select v-if="groupList.item2.selectOrinput" id="select" @change='selectChange(groupList.item2.selectValue)' class="inputInner" v-model="groupList.item2.selectValue" placeholder="请选择">
                            <el-option
                            v-for="item in groupList.item2.selectOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                        <label v-if="!groupList.item2.selectOrinput" class="input_label" for="input">{{groupList.item2.lable}}</label>
                        <el-input v-if="!groupList.item2.selectOrinput" id="input" class="inputInner" v-model="groupList.item2.inputValue" placeholder="请输入内容"></el-input>
                    </div>
                    <div id="main">
                        <div class="main_head">
                            <h1>船舶使用管理</h1>
                        </div>
                        <div class="main_body">
                            <div id="main2">
                
                             </div>
                        </div>
                    </div>
        </div>
        
    </div>
</template>

<script>
import * as echarts from 'echarts';
import API from '@/api/material';
import moment from 'moment';
export default {
    
    name:'overview',
    data(){
        return{
            groupList:{
                item1:{
                    isShow:false,
                    selectOrinput:true, //1 select 0 input
                    lable:'lable',
                    selectOptions:[
                        {
                            value:'',
                            label:''
                        },
                    ],
                    placeHolder:'',
                    selectValue:null,
                    inputValue:null,
                },
                item2:{
                    isShow:true,
                    selectOrinput:true, //1 select 0 input
                    lable:'选择船舶',
                    selectOptions:[],
                    placeHolder:'',
                    selectValue:null,
                    inputValue:null,
                },
            },
            domChar1:'',
            domChar2:'',
            AllClass:this.$store.state.AllClass,
            datasetSource:[[]],
            datasetSource2:[[]],
        }
    },
    methods:{
        getCharts1(){
            var app = {};
            let myChart = echarts.getInstanceByDom(document.getElementById('main1'));
            if(!myChart){
                myChart = echarts.init(document.getElementById('main1'))
            }    
            var option;
            let a = this.datasetSource2;
            option = {
            legend: {},
            tooltip: {},
            dataset: {
                source: a
            },
            xAxis: { type: 'category' },
            yAxis: {},
            // Declare several bar series, each will be mapped
            // to a column of dataset.source by default.
            series: [{ type: 'bar' }, { type: 'bar' }, { type: 'bar' }, { type: 'bar' }]
            };

            option && myChart.setOption(option);
        },
        getCharts2(){
            var app = {};
            let myChart = echarts.getInstanceByDom(document.getElementById('main2'));
            if(!myChart){
                myChart = echarts.init(document.getElementById('main2'));
            };
            var option;
            
            option = {
            legend: {},
            tooltip: {},
            dataset: {
                source:this.datasetSource
            },
            xAxis: { type: 'category' },
            yAxis: {},
            // Declare several bar series, each will be mapped
            // to a column of dataset.source by default.
            series: [{ type: 'bar' }, { type: 'bar' }, { type: 'bar' }, { type: 'bar' }]
            };

            option && myChart.setOption(option);
        },
        getShipList(){
            for (let index = 0; index < this.AllClass.AllShip.length; index++) {
                this.groupList.item2.selectOptions.push({
                    label:this.AllClass.AllShip[index].boat_id,
                    value:this.AllClass.AllShip[index].boat_id,
                });  
            };
            let defaultNum = this.groupList.item2.selectOptions[0].value;
            this.groupList.item2.selectValue = defaultNum;
            this.divideMaterialById(0,defaultNum,'datasetSource');
        },
        selectChange(val){
            this.divideMaterialById(0,val,'datasetSource');
        },
        getAll(){
          return  new Promise((resolve,reject)=>{
                API.getMaterial_getall(this.$store.state.API_params).then(res=>{
                        this.AllClass.AllMaterialSubMenu = res.message.obj;
                        resolve(res.message.obj)
                    }).catch(err=>{
                        console.log(err);
                    });
            })
            
        },
        formattingList(lists){
            let list = lists?lists:[];
            let source=[],arr=[];
            for(var idx = 0;idx< list.length;idx++){
                let date = moment(list[idx].entryTime).format('YYYY-MM-DD');
                source.push([moment(date).format('yy'),moment(date).format('MM'),list[idx].number]);
            };
            return source;
        },
        apiGetsource(param,temp){
           return new Promise((resolve, reject) => {
                    API.getMaterialById(param).then(res=>{
                        resolve(res.message.obj)
                    }).catch((err)=>{console.log(err);})
           })        
        },
        DistinguishedByShipId(lists,boatId){
            let list = lists?lists:{}
            let arr = Object.keys(list)
            for(let i = 1;i <=arr.length;i++){
                for(let j = 0;j <list[`${i}`].length;j++){
                    if(list[`${i}`][`${j}`].boatId != boatId && boatId!=null){
                        list[`${i}`].splice(j,1);
                        j--;
                    }
                }
            }
            return list
        },
        async divideMaterialById(switcher,boatId,datasetSource){
            if(switcher == 0){
                let list = this.$store.state.AllClass.AllMaterialType?this.$store.state.AllClass.AllMaterialType:[];
                let param = this.$store.state.API_params4;
                await this.apiGetsource(param).then(res =>{
                        this.AllClass.chartsSource = this.DistinguishedByShipId(res,boatId);
                        this.AllClass.chartsFormat = []
                        for(var i = 1;i <= list.length;i++){
                            this.AllClass.chartsFormat.push(this.formattingAndRetreiveSource(this.formattingList(this.AllClass.chartsSource[`${i}`]),new Date().getFullYear())); 
                        };
                    });
                    if(this.AllClass.chartsFormat =='[]'){
                        return
                    }else{
                            console.log('this.AllClass.chartsFormat',this.AllClass.chartsFormat);
                            this.summaryChartSource(this.AllClass.chartsFormat,datasetSource);   
                            this.$nextTick(()=>{
                                this.getCharts1();
                                this.getCharts2();  
                            })
                    }
            }
            
        },
        formattingAndRetreiveSource(source,year){
            let temp=[],temp2=[],tempMonth=[],sum = 0,temp3 = [];
            let counter = 0;
            for(var idx =0; idx < source.length;idx++){
                if(source[idx][0] == year){
                    temp.push(source[idx]);
                }
            };
            for(var i = 0 ;i<temp.length;i++){
                temp2.push(temp[i][1]);
            };
            for(var i = 0 ;i<temp2.length;i++){
                let cunrrent = temp2[i];
                if(tempMonth.indexOf(cunrrent) ==-1 ){
                    tempMonth[counter] = temp2[i];
                    temp3.push([tempMonth[counter],sum]);
                    counter++;
                }
                    for(var x = 0;x <= counter;x++){
                        tempMonth[x] == temp2[i]? temp3[x][1] += parseInt(temp[i][2] ):0;
                        
                    }
            
            };
            return  temp3
        },
        summaryChartSource(lists,datasetSource){
            let list = lists?lists:[]
            let dataSet =[];
            let monthArr =[];
            let counter = 0;
            this[`${datasetSource}`] = [[]];
            for(var i =0; i<list.length;i++){                       // i:unidimensional, j:two-dimension,
                for(var j = 0;j <list[i].length;j++){               //if montheArr dosen't contain a number from j list，  
                    if(monthArr.indexOf(list[i][j][0]) ==-1 ){      //then we push the new number into it.
                        monthArr.push(list[i][j][0]);
                        let tempArr = [list[i][j][0]];
                        for(var y =0; y<list.length;y++){
                            tempArr.push(0);
                        };
                        this[`${datasetSource}`].push(tempArr);
                        counter++;
                    }
                    for(var x = 0;x < counter;x++){                 //according to i, enumerating a number from j list and matching it with monthArr.
                            if(monthArr[x] == list[i][j][0]){       //true:summary the number of type i,false:next one.
                                this[`${datasetSource}`][x+1][i+1] += parseInt(list[i][j][1]);
                            }
                    }
                }     
            }
            //make title for echarts source data
            let typearr = this.$store.state.AllClass.AllMaterialType    
            this[`${datasetSource}`][0].push('材料类型')
            for(var i = 0;i < typearr.length;i++){
                this[`${datasetSource}`][0].push(typearr[i].materialName)
            }
            console.log(' this[`${datasetSource}`]', this[`${datasetSource}`]);
        },
 
    },
    created(){
        this.getShipList();
        this.getAll().then(res=>{
            if(res != null){
                this.divideMaterialById(0,null,'datasetSource2');
            }else{
                this.$message({
                    type:'error',
                    message:'数据交互异常'
                });
            }
            
        })
    },
    mounted(){
    },
}
</script>

<style scoped>
.overview{
    width: 100%;
    height: 90%;
    display: flex;
    align-items: center;
    justify-content: space-around;
}
.charts{
    height: 100%;
    width: 40%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
}
/* #main1{
    height: 80%;
    width: 100%;
    background-color: var(--subject--input);
    border-radius: var(--border--radius);
} */
/* #main2{
    height: 80%;
    width: 100%;
    background-color: var(--subject--input);
    border-radius: var(--border--radius);
} */
.input_group{
    height: 20%;
    width: 100%;
}
</style>>


